// src/components/BookFormatCard.js
//
// One purchase card, shared by all three formats on BuyBook.js. Presentation
// only — all state/validation/navigation logic lives in usePurchaseForm.
import { useState } from 'react';

const COUNTRIES = ['USA', 'Canada', 'United Kingdom', 'France', 'Germany', 'Haiti', 'Kenya'];

function BookFormatCard({
  form,
  badge,
  image,
  format,
  title,
  description,
  price,
  originalPrice,
  features = [],
  ctaLabel,
  needsShipping = false,
  moreInfo,
  highlighted = false,
}) {
  const [expanded, setExpanded] = useState(false);
  const { fields, handleChange, error, submit, subtotal, submitting } = form;

  const savingsPct = originalPrice
    ? Math.round((1 - price / originalPrice) * 100)
    : null;

  return (
    <div className={`format-card${highlighted ? ' is-highlighted' : ''}`}>
      {badge && <div className="format-card-badge">{badge}</div>}

      <div className="format-card-media">
        <img src={image} alt={`${title} — ${format}`} loading="lazy" />
      </div>

      <div className="format-card-format">{format}</div>
      <div className="format-card-title">{title}</div>

      <div className="format-card-price-row" style={{ marginTop: "-5px" }}>
        <span className="format-card-price">${Number(price).toFixed(2)}</span>
   
      </div>
      {/* {savingsPct > 0 && (
        <div className="format-card-savings">Save {savingsPct}% today</div>
      )} */}

  

      

      <div className="format-card-form">
        {!expanded ? (
          <button
            type="button"
            className="format-card-form-toggle"
            onClick={() => setExpanded(true)}
          >
             {ctaLabel} <i className="bi bi-arrow-right" />
          </button>
        ) : (
          <form onSubmit={submit} className="format-card-form-fields">
            <div className="format-card-qty-row">
              <label htmlFor={`qty-${format}`}>Quantity</label>
              <input
                id={`qty-${format}`}
                name="qty"
                type="number"
                min="1"
                value={fields.qty}
                onChange={handleChange}
              />
            </div>

            <div className="format-card-subtotal">
              <span>Subtotal</span>
              <span>${Number(subtotal || 0).toFixed(2)} USD</span>
            </div>
            <div className="format-card-tax-note">Taxes{needsShipping ? ' and shipping' : ''} calculated at checkout</div>

            {error && <div className="format-card-error">{error}</div>}

            <input
              className="input_part2_jett2"
              placeholder="Full name"
              name="name"
              type="text"
              required
              value={fields.name}
              onChange={handleChange}
            />
            <input
              className="input_part2_jett2"
              placeholder="Phone"
              name="phone"
              type="tel"
              required
              value={fields.phone}
              onChange={handleChange}
            />
            <input
              className="input_part2_jett2"
              placeholder="Email address"
              name="email"
              type="email"
              required
              value={fields.email}
              onChange={handleChange}
            />

            {!needsShipping && (
              <select
                className="input_part2_jett2"
                name="country"
                required
                value={fields.country}
                onChange={handleChange}
              >
                <option value="" disabled>Select your country</option>
                {COUNTRIES.map((c) => <option key={c} value={c}>{c}</option>)}
              </select>
            )}

            {needsShipping && (
              <>
                <input
                  className="input_part2_jett2"
                  placeholder="Street address"
                  name="street"
                  type="text"
                  required
                  value={fields.street}
                  onChange={handleChange}
                />
                <input
                  className="input_part2_jett2"
                  placeholder="City"
                  name="city"
                  type="text"
                  required
                  value={fields.city}
                  onChange={handleChange}
                />
                <input
                  className="input_part2_jett2"
                  placeholder="State / Province"
                  name="state_province"
                  type="text"
                  required
                  value={fields.state_province}
                  onChange={handleChange}
                />
                <input
                  className="input_part2_jett2"
                  placeholder="Postal / ZIP code"
                  name="postal_ZIP_code"
                  type="text"
                  required
                  value={fields.postal_ZIP_code}
                  onChange={handleChange}
                />
                <select
                  className="input_part2_jett2"
                  name="country"
                  required
                  value={fields.country}
                  onChange={handleChange}
                >
                  <option value="" disabled>Select your country</option>
                  <option value="USA">USA</option>
                  <option value="Canada">Canada</option>
                </select>
              </>
            )}

            <textarea
              className="input_part2_jett2"
              placeholder="Order note (optional)"
              name="description"
              value={fields.description}
              onChange={handleChange}
            />

            <button type="submit" className="format-card-submit" disabled={submitting}>
              {submitting ? (
                <><i className="bi bi-arrow-repeat" /> Redirecting to checkout…</>
              ) : (
                <><i className="bi bi-lock-fill" /> Proceed to safe checkout</>
              )}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

export default BookFormatCard;
